import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TextBlock}
 */
const Text = ({ richText }) => {
    return (
        <section
            className='col-padding w-full sm:w-8/9 md:w-3/4 rich-text type-style-serif-body'
            dangerouslySetInnerHTML={{ __html: richText}}/>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Text;
